import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

// ---------------------------------------------------------------------------
// CRM provider availability info — returned by the `getCrmConfig` baseQL
// query so the UI knows which providers can be offered (and in which mode).
// Plain AdornisEntity (no _id / collection): pure transport DTO.
// ---------------------------------------------------------------------------

@Entity()
export class HubspotConfigInfo extends AdornisEntity {
  static override _class = 'HubspotConfigInfo';

  @Field(type => Boolean) enabled!: boolean;
  /** 'private_app' | 'oauth' | 'disabled' */
  @Field(type => String) mode!: string;
  @Field(type => Boolean) oauthAvailable!: boolean;
}

@Entity()
export class CrmConfigInfo extends AdornisEntity {
  static override _class = 'CrmConfigInfo';

  @Field(type => HubspotConfigInfo) hubspot!: HubspotConfigInfo;
}
